import { FieldInput } from "@/components/form/field-input";
import { FieldTextarea } from "@/components/form/field-textarea";

interface OrganizationFormFieldsProps {
  isDisabled?: boolean;
}

export function OrganizationFormFields({
  isDisabled = false,
}: OrganizationFormFieldsProps) {
  return (
    <>
      <FieldInput
        name="companyCode"
        label="Company Code"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="companyName"
        label="Company Name"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="department"
        label="Department"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="noTelp"
        label="No Telp"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="email"
        label="Email"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldTextarea
        name="address"
        label="Address"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
    </>
  );
}
